<template>
    <div>
        <div class="table-wrap">
            <table class="board_table">
                <colgroup>
                    <col width="auto" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                </colgroup>
                <thead>
                    <tr>
                        <th rowspan="2">키워드</th>
                        <th rowspan="2">검색 횟수</th>
                        <th colspan="5">플랫폼별 검색 결과</th>
                        <th rowspan="2">
                            평균
                            <br />
                            (검색 결과)
                        </th>

                        <th rowspan="2">
                            합계
                            <br />
                            (검색 결과)
                        </th>
                        <th rowspan="2">모니터링</th>
                    </tr>
                    <tr>
                        <th>X(구 트위터)</th>
                        <th>구글</th>
                        <th>네이버</th>
                        <th>유튜브</th>
                        <th>인스타그램</th>
                    </tr>
                </thead>
                <template v-if="!props.loading">
                    <template v-if="props.list.length > 0">
                        <tbody>
                            <tr v-for="value in props.list">
                                <td v-text="value.keyword"></td>
                                <td v-text="value.cntSearch ? value.cntSearch.toLocaleString() : 0"></td>
                                <td v-text="value.cntTwitter ? value.cntTwitter.toLocaleString() : 0"></td>
                                <td v-text="value.cntGoogle ? value.cntGoogle.toLocaleString() : 0"></td>
                                <td v-text="value.cntNaver ? value.cntNaver.toLocaleString() : 0"></td>
                                <td v-text="value.cntYoutube ? value.cntYoutube.toLocaleString() : 0"></td>
                                <td v-text="value.cntInstagram ? value.cntInstagram.toLocaleString() : 0"></td>
                                <td
                                    v-text="
                                        value.cntResult ? (Math.round((value.cntResult / value.cntSearch) * 10) / 10).toLocaleString() : 0
                                    "
                                ></td>
                                <td v-text="value.cntResult ? value.cntResult.toLocaleString() : 0"></td>
                                <td v-text="value.cntMonitoring ? value.cntMonitoring.toLocaleString() : 0"></td>
                            </tr>
                        </tbody>
                    </template>
                    <tbody v-else>
                        <tr>
                            <td :colspan="10" class="spinner_table">검색된 결과가 없습니다.</td>
                        </tr>
                    </tbody>
                </template>
                <tbody v-else>
                    <tr>
                        <td :colspan="10">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
            <PageBtn
                :currentPage="props.currentPage"
                :totalLength="props.totalLength"
                :perPage="props.perPage"
                @onPaging="(page: number) => emit('onPaging', page)"
            ></PageBtn>
        </div>
    </div>
</template>

<script lang="ts" config>
    import { Spinner, PageBtn } from "@/BaseComponent";
    export default {
        props: ["list", "loading", "totalLength", "currentPage", "perPage"],
        emits: ["onPaging"],
        components: {
            Spinner,
            PageBtn,
        },
        setup(props: any, { emit }: any) {
            return {
                props,
                emit,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }
    .spinner_table {
        height: 150px !important;
    }
</style>
